<template>
  <q-card square id="xyz" class="sticky-header-card">
    <div class="center-sticky-header">
      <vehicle-sub-menu class="sticky-fully-v2">
        <template v-slot:activator>
          <div class="sticky-add">
            <!-- <q-btn
              round
              @click="$store.commit('vehicle/SET_VEHICLE_OPERATION', true)"
              color="red"
              size="sm"
            >
              <q-icon name="fas fa-plus"></q-icon>
            </q-btn> -->
            <q-btn-dropdown color="red" size="sm" label="" icon="fas fa-plus">
              <q-list>
                <q-item clickable @click="$store.commit('vehicle/SET_VEHICLE_OPERATION', true)">
                  <q-item-section>
                    <q-item-label>Single</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable @click="$router.push('/vehicles/batch')">
                  <q-item-section>
                    <q-item-label>Vehicle Batch</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable @click="$router.push('/vehicles/financial-batch')">
                  <q-item-section>
                    <q-item-label>Financial Batch</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable @click="$router.push('/class-performances/batch')">
                  <q-item-section>
                    <q-item-label>Class Performance Batch</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div>
          <div class="sticky-add" style="margin-left:5px">
            <q-btn
              :disable="selectedVehicles.length === 0 || $store.state.tag.tags.length === 0"
              round
              @click="$store.commit('vehicle/SET_TAG_OPERATION', true)"
              color="primary"
              size="sm"
            >
              <q-icon name="fas fa-tags"></q-icon>
            </q-btn>
          </div>
          <div class="sticky-add" style="margin-left:5px">
            <q-btn round color="grey-7" size="sm">
              <q-icon name="fas fa-caret-down"></q-icon>
              <q-menu>
                <q-select
                  outlined
                  v-model="visibleColumns"
                  multiple
                  :options="columns"
                  :option-label="col => col.name"
                  :option-value="col => col.val"
                  label="Visible Columns"
                  style="width: 250px"
                />
              </q-menu>
            </q-btn>
          </div>
        </template>
      </vehicle-sub-menu>
      <div class="sticky-sub-menu">
        <div class="filter-info">
          Filters:
          <q-badge v-if="anyFilter" color="negative">NONE</q-badge>
          <q-badge style="margin-right:5px" outline color="positive" v-if="companyFilter && companyFilter.name"
            >Company : {{ companyFilter && companyFilter.name ? companyFilter.name : '' }}</q-badge
          >
          <q-badge style="margin-right:5px" outline color="info" v-if="multiFilter > 0"
            >Locations:{{ multiFilter }}</q-badge
          >
          <q-badge style="margin-right:5px" outline color="warning" v-if="search">Search: {{ search }}</q-badge>
        </div>
        <div class="sticky-add">
          <q-btn round @click="$store.commit('vehicle/SET_VEHICLE_OPERATION', true)" color="red" size="xs">
            <q-icon name="fas fa-plus" style="margin-top:3px"></q-icon>
          </q-btn>
        </div>

        <q-icon
          color="grey-7"
          @click="subMenu = true"
          name="fas fa-caret-down"
          class="cursor-pointer"
          size="25px"
        ></q-icon>

        <q-dialog v-model="subMenu" persistent transition-show="scale" transition-hide="scale">
          <q-card style="width: 300px">
            <div class="bg-primary text-white sub-menu-title">
              <div class="text-h6">Filters</div>

              <q-icon @click="subMenu = false" name="fas fa-times" class="cursor-pointer"></q-icon>
            </div>
            <vehicle-sub-menu class="sub-menu-filters">
              <template v-slot:activator>
                <div class="row">
                  <q-btn
                    label="Close"
                    size="md"
                    @click="subMenu = false"
                    color="negative"
                    style="width:calc(50% - 5px);margin-right:5px"
                  ></q-btn>
                  <q-btn
                    size="md"
                    label="RESET"
                    color="primary"
                    :disable="anyFilter"
                    style="width:calc(50%)"
                    @click="
                      $store.commit('vehicle/RESET_FILTER', true)
                      subMenu = false
                    "
                  ></q-btn>
                </div>
              </template>
            </vehicle-sub-menu>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </q-card>
</template>

<script>
import VehicleSubMenu from './VehicleSubMenu'
import axios from '../axios/index'
export default {
  components: {
    VehicleSubMenu
  },
  data() {
    return {
      columns: [
        {
          name: 'SELECT',
          val: 'selection'
        },
        {
          name: 'UNIT',
          val: 'unit'
        },
        {
          name: 'VIN',
          val: 'vin'
        },
        {
          name: 'BRAND',
          val: 'brand'
        },
        {
          name: 'MODEL',
          val: 'model'
        },
        {
          name: 'MODEL YEAR',
          val: 'model_year'
        },
        {
          name: 'CLASS NAME',
          val: 'class_name'
        },
        {
          name: 'LOCATION',
          val: 'location'
        },
        {
          name: 'CONDITION',
          val: 'condition'
        },
        {
          name: 'AUCTION VALUE',
          val: 'last_mileage_record'
        },
        {
          name: 'MANUAL SELECTION',
          val: 'tags'
        },
        {
          name: 'ACTIONS',
          val: 'actions'
        }
      ],
      subMenu: false
    }
  },
  async mounted() {
    if (this.$store.state.company.companies.length === 0) await this.getCompanies()
  },
  methods: {
    async getCompanies() {
      const { data } = await axios.get('companies')
      this.companies = data.data
    }
  },
  computed: {
    visibleColumns: {
      get() {
        return this.$store.state.vehicle.visibleColumns
      },
      set(val) {
        this.$store.commit('vehicle/SET_VISIBLE_COLUMNS', val)
      }
    },
    drawer() {
      return this.$store.state.layout.drawer
    },
    anyFilter() {
      if (
        (this.companyFilter && this.companyFilter.name) ||
        this.multiFilter > 0 ||
        this.search ||
        this.visibleColumns.length === 8
      )
        return false
      else {
        return true
      }
    },
    search() {
      return this.$store.state.vehicle.search
    },
    companyFilter() {
      return this.$store.state.vehicle.companyFilter
    },
    multiFilter() {
      return this.$store.state.vehicle.multiFilter.length
    },
    grid: {
      get() {
        return this.$store.state.vehicle.grid
      },
      set(val) {
        this.$store.commit('vehicle/SET_GRID_TYPE', val)
      }
    },
    companies: {
      get() {
        return this.$store.state.company.companies
      },
      set(val) {
        this.$store.commit('company/SET_USER_COMPANIES', val)
      }
    },
    selectedVehicles: {
      get() {
        return this.$store.state.vehicle.selectedVehicles
      },
      set(val) {
        this.$store.commit('vehicle/SET_SELECTED_VEHICLES', val)
      }
    }
  }
}
</script>

<style lang="scss">
.sticky-fully-v2 {
  display: flex;
  align-items: center;
  margin: 0px 18px;
  flex: 0 1 calc(100% - 18px);
  .sticky-select {
    flex: 0 1 20%;
  }
  .sticky-search {
    margin-left: 5px;
    flex: 0 1 20%;
  }
  .sticky-location {
    margin-left: 5px;
    flex: 0 1 20%;
  }
  .flex-1 {
    flex: 1;
  }
}
</style>
